import React, { useState } from "react";
import InPlaceError from "components/in-place-error/InPlaceError";
import { createAutoCorrectedDatePipe } from "text-mask-addons";
import './dob.scss';
import MaskedInput from "react-text-mask";
import { getYearDifference } from "utilities/date";
import WarningMessage from "components/ui/warning-message/WarningMessage";
import { ALLOWED_YEAR_START_VALUE, DATE_LIMIT_WARNING_MESSAGE, YEAR_WARNING_LIMIT_VALUE } from "utilities/Constant";
import { globalLinkNoTxClass } from "utilities/globalLinkNoTx";

interface InputProps {
    onChange: (formattedDate: string) => void;
    errorMessage?: string;
    label?: string;
    initialValue?: string;
}

export const Label = ({ label }: { label: string }) => {
    return (
        <div className="dateField-label-wrapper">
            <label htmlFor="label" className="dateField-label">
                {label}
            </label>
        </div>
    );
};

export const Dob = ({
    onChange,
    errorMessage,
    label,
    initialValue,
}: InputProps) => {
    const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
        "mm/dd/yyyy"
    ) as undefined;

    const formatToMMDDYYYY = (dateString: string | null): string => {
        if (!dateString) {
            return "";
        }
        const parsedDate = new Date(dateString);
        if (!Number.isNaN(parsedDate.getTime())) {
            return `${String(parsedDate.getMonth() + 1).padStart(2, "0")}/${String(parsedDate.getDate()).padStart(2, "0")}/${parsedDate.getFullYear()}`;
        }
        return "";
    };

    const [inputValue, setInputValue] = useState<string>(formatToMMDDYYYY(initialValue ?? null));
    const [showWarning, setShowWarning] = useState(false);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: input } = event.target;
        setInputValue(input);
        const parsedDate = new Date(input);
        const formattedDate = `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, "0")}-${String(parsedDate.getDate()).padStart(2, "0")}`;
        onChange(formattedDate);
        const currentDate = new Date();
        const yearDifference = getYearDifference(parsedDate, currentDate)
        if (!(parsedDate < new Date(ALLOWED_YEAR_START_VALUE, 0, 1) || parsedDate > currentDate) && (yearDifference >= YEAR_WARNING_LIMIT_VALUE)) {
            setShowWarning(true);
        } else {
            setShowWarning(false);
        }
    };

    return (
        <div className={"dob-container"} >
            {showWarning && !errorMessage && <WarningMessage message={DATE_LIMIT_WARNING_MESSAGE} />}
            {label && <Label label={label} />}
            <MaskedInput
                pipe={autoCorrectedDatePipe}
                mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
                keepCharPositions
                guide
                aria-label={label}
                className={globalLinkNoTxClass(`dob ${errorMessage ? "dob--error" : ""}`)}
                placeholder="mm/dd/yyyy"
                value={inputValue}
                onChange={handleInputChange}
                data-testid="pii-dob-input"
            />
            {errorMessage && <InPlaceError errorPhrase={errorMessage} />}
        </div>
    );
};

export default Dob;
